import { render } from "./VehicleBpmData.vue?vue&type=template&id=4b16ede0"
import script from "./VehicleBpmData.vue?vue&type=script&lang=js"
export * from "./VehicleBpmData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__